import devices from "./devices";
import meetings from "./meetings";
import rooms from "./rooms";
import tickets from "./tickets";
import accounts from "./accounts";
import countries from "./countries";
import locations from "./locations";
import users from "./users";
import triggers from "./triggers";
import audit from "./auditTrails";
import workflows from "./workflows";
import deviceCatalog from "./deviceCatalog";

export const Rooms = rooms;
export const Devices = devices;
export const Meetings = meetings;
export const Tickets = tickets;
export const Accounts = accounts;
export const Countries = countries;
export const Locations = locations;
export const Users = users;
export const Triggers = triggers;
export const AuditTrails = audit;
export const Workflows = workflows;
export const DeviceCatalog = deviceCatalog;
export default {
  Rooms,
  Devices,
  Meetings,
  Tickets,
  Accounts,
  Countries,
  Locations,
  Users,
  Triggers,
  AuditTrails,
  Workflows,
  DeviceCatalog,
};
